import AppRecord from './AppRecord.js'

class UpdateMessagePolicy extends AppRecord {

    get controller_name(){
        return 'UpdateMessagePoliciesController'
    }
}

export default UpdateMessagePolicy
